import { LegalLayout } from "@/components/legal/LegalLayout";
import { useI18n } from "@/i18n";

export default function Privacy() {
  const { t } = useI18n();
  return <LegalLayout page="privacy" path="/privacy" content={t("legal.privacy")} testid="privacy-page" />;
}
